import { FormikValues } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';

import { Card } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';

import AppSnackbar from '../../../common/AppSnackbar';
import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';
import InlineForm from '../../../common/inline/InlineForm';
import InlineFormik from '../../../common/inline/InlineFormik';
import InlineTextField from '../../../common/inline/InlineTextField';
import { useFindGroup, useUpdateGroup } from '../Group.hooks';
import { Group } from '../Group.interface';

export interface GroupInfoCardProps {
  groupId: number;
  onChange?: (group: Group) => void;
}

const getInitialValues = (group?: Group) => {
  return {
    name: group?.name || '',
    description: group?.description || ''
  };
};

const GroupInfoCard: React.FC<GroupInfoCardProps> = ({ groupId, onChange }) => {
  const onChangeRef = useRef(onChange); // prevent circular refresh
  const formikRef = useRef<FormikValues>();
  const {
    group,
    isLoading: isLoadingInitialValues,
    error: findError
  } = useFindGroup(groupId, true);
  const { isLoading: isUpdating, error: updateError, patch } = useUpdateGroup(
    groupId
  );

  const [initialValues, setInitialValues] = useState<{
    name: string;
    description: string;
  }>();

  // set the initial state of the form once loaded
  useEffect(() => {
    if (!isLoadingInitialValues && group) {
      setInitialValues(getInitialValues(group));
    }
  }, [isLoadingInitialValues, group]);

  // notify parent when a record is updated
  useEffect(() => {
    if (group && onChangeRef && onChangeRef.current) {
      onChangeRef.current(group);
    }
  }, [group]);
  return (
    <Card>
      <CardTitle>
        <PersonIcon />
        Team Info
      </CardTitle>
      <CardContent padding='large'>
        <InlineFormik
          innerRef={(formik: any) => (formikRef.current = formik)}
          initialValues={initialValues}
          validationSchema={Yup.object({
            name: Yup.string().required('Required')
          })}
          isSubmitting={isUpdating}
          error={findError}
          onSubmit={(group: Partial<Group>) => {
            console.log('onSubmit', group);
            patch(group);
          }}
        >
          <InlineForm>
            <InlineTextField
              name='name'
              label='Name'
              placeholder='What is the name?'
              grid={{ xs: 12, md: 12 }}
            />
            <InlineTextField
              name='description'
              label='Description'
              placeholder='What is the description?'
              grid={{ xs: 12, md: 12 }}
            />
          </InlineForm>
        </InlineFormik>
        <AppSnackbar severity='error' open={Boolean(updateError)}>
          There was an error saving.
        </AppSnackbar>
      </CardContent>
    </Card>
  );
};

export default GroupInfoCard;
